/* eslint-disabled */

export default class SmsJobExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
